import Form from "../../componets/Form";

export default function Section4() {
  return (
    <Form />
  );
}
